module.exports = __webpack_public_path__ + "static/media/industries-glass-s.38b9e4ba.jpg";